import { AccessFlags } from '@/services/innovorder/auth/auth.type';

/**
 * List of access flags that a brand user with CAN_MANAGE_BO_USERS permission
 * can edit on other users (brand/restaurant users they manage).
 */
export const BRAND_EDITABLE_ACCESS_FLAGS: AccessFlags[] = [
    AccessFlags.CAN_ACCESS_BRAND_HISTORY,
    AccessFlags.CAN_ACCESS_CUSTOMERS_SECTION,
    AccessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION,
    AccessFlags.CAN_ARCHIVE_CUSTOMERS,
    AccessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY,
    AccessFlags.CAN_CHANGE_OWN_PASSWORD,
    AccessFlags.CAN_CREATE_SKU,
    AccessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET,
    AccessFlags.CAN_EDIT_AREAS,
    AccessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS,
    AccessFlags.CAN_EDIT_TABLE_LAYOUT,
    AccessFlags.CAN_EXPORT_CUSTOMERS_CSV,
    AccessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE,
    AccessFlags.CAN_MANAGE_BO_USERS,
    AccessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT,
    AccessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT,
    AccessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME,
    AccessFlags.MENU_CATEGORY_CREATE_OR_DELETE,
    AccessFlags.MENU_CATEGORY_EDIT,
    AccessFlags.MENU_CREATE_OR_DELETE,
    AccessFlags.MENU_EDIT,
    AccessFlags.MENU_PRODUCT_CREATE_OR_DELETE,
    AccessFlags.MENU_PRODUCT_EDIT,
    AccessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY,
    AccessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY,
    AccessFlags.MENU_STEP_CREATE_OR_DELETE,
    AccessFlags.MENU_STEP_EDIT,
    AccessFlags.MENU_TAG_CREATE_OR_DELETE,
    AccessFlags.MENU_TAG_EDIT,
];
